import { preloadPersonalSpaceDetail } from '@confluence/space-utils/entry-points/index.ts';

import { preloadHome } from '@confluence/home/entry-points/preloadHome.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { preloadPostOfficeConfluenceSideNav } from '@confluence/experiment-post-office-side-nav/entry-points/preloadConfluenceSideNav.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';

//***************************************************
// This preloader fires for 5 different Routes!
// Only Shared preloading should go into this file!
// Home overview
// Drafts
// All Starred
// Recent Pages
// Tasks does not appear to have  a preloader yet
// any load specific to one of those routes should go into the specific  preloader in next/packages/home/src/Home/HomeViews
//***************************************************
export const preloadHomeRoute = async (match: RouteMatch) => {
	const preloadedSessionContext = getPreloaderFnContext();
	const { userId, cloudId, accessStatus } = preloadedSessionContext;

	const isDatabasesEnabled = isContentTypeEnabledInCurrentEnv('database');
	const isSlidesEnabled = isContentTypeEnabledInCurrentEnv('slide');
	const isWhiteboardsEnabled = isContentTypeEnabledInCurrentEnv('whiteboard');

	const tasks: Promise<any>[] = [];

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	const canAccessHome =
		accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';

	//All top Navigation preloading is done in next/packages/query-preloaders/src/index.ts
	if (isLicensed && canAccessHome) {
		tasks.push(
			preloadHome({
				cloudId,
				isLicensed,
				userId,
				matchParams: match.params,
				isWhiteboardViewedEnabled: isWhiteboardsEnabled,
				isDatabaseEnabled: isDatabasesEnabled,
				isSlidesEnabled,
			}),
		);
	}

	// Preload current user's personal space metadata for home route consumers(onboarding etc).
	tasks.push(preloadPersonalSpaceDetail());

	tasks.push(preloadPostOfficeConfluenceSideNav());

	return waitForAllReturnWhenError(tasks);
};
